import React from "react";
// import "./BadgeComponent.css";

export interface myComponentProps {
  className?: string;
  text?: string;
  onClick?: (param?: any) => void;
  children?: React.ReactNode;
  type?: string;
  style?: React.CSSProperties;
  padding?: string;
  stopPropagation?: boolean;

}



const RavenBadge: React.FC<myComponentProps> = ({
  text,
  className,
  children,
  onClick,
  type,
  style,
  padding,
 
}) => {
  const getColor = () => {
    let val;
    if (type === "default") {
      val = "default";
    } else if (type === "yellow") {
      val = "pending";
    } else if (type === "green") {
      val = "success";
    } else if (type === "red") {
      val = "failed";
    } else if (type === "info") {
      val = "info";
    } else if (type === "purple") {
      val = "purple";
    }

    return val;
  };
  return (
    <div
      onClick={(e) => {
        if (onClick) {
          e.stopPropagation();
          onClick();
        }
        // onClick && onClick();
      }}
      className={`badge-reusable-wrap-index`}
    >
      <div
        className={`badge-wrap-index ${className?.toLowerCase()} ${
          type ? getColor() : ""
        }  grey-bg-two`}
        style={{ ...({ "--padding-val": padding || "0.65rem 1.5rem" } as React.CSSProperties), ...style }}
      >
        {children} <span>{text || ""}</span>
      </div>
    </div>
  );
};

export default RavenBadge;

